import React from "react";
import UserDashboard from "../UserDashboard/UserDashboard";

// Archiwum odpraw - ten sam widok co dashboard, z danymi zakończonych odpraw.
const Archive = () => <UserDashboard view="archiwum" />;

export default Archive;
